import React from "react"
import "./TextInput.css"

function TextInput({
  inputType,
  placeHolder,
  name,
  label,
  value,
  onChange,
  error,
  success
}) {
  return (
    <span
      className={`TextInput ${error ? "error" : ""} ${
        success ? "success" : ""
      }`}
    >
      {label ? <label>{label}</label> : null}
      <input
        type={inputType ? inputType : "text"}
        placeholder={placeHolder}
        name={name}
        autoComplete="off"
        value={value}
        onChange={onChange}
      />
      {error ? <p>{error}</p> : null}
    </span>
  )
}

export default TextInput
